import {useContext} from 'react';
import {Context as BillContext} from '../contexts/BillContext';

export const useBill = () => useContext(BillContext);
